import { render, staticRenderFns } from "./AdminDueDiligenceReportsComponent.vue?vue&type=template&id=27fd4080&scoped=true"
import script from "./AdminDueDiligenceReportsComponent.vue?vue&type=script&lang=js"
export * from "./AdminDueDiligenceReportsComponent.vue?vue&type=script&lang=js"
import style0 from "./AdminDueDiligenceReportsComponent.vue?vue&type=style&index=0&id=27fd4080&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fd4080",
  null
  
)

export default component.exports